import React, { useRef, useEffect } from "react";
import { Trad } from "../../../components/";
interface IAutocompleteInputProps {
    OnPlaceChange: (address: object) => any;
}

const ProvinceResultType: string = "administrative_area_level_2";

export const AutocompleteInput: React.FC<IAutocompleteInputProps> = ({ OnPlaceChange }) => {
    const autocompleteInput = useRef<HTMLInputElement>(null);
    let autocomplete: google.maps.places.Autocomplete;

    useEffect(() => {
        if (autocompleteInput.current) {
            autocomplete = new google.maps.places.Autocomplete(autocompleteInput.current, { types: ["geocode"] });
            autocomplete.setFields(["address_component"]);
            autocomplete.addListener("place_changed", handlePlaceChanged);
        }
    }, []);

    const handlePlaceChanged = () => {
        const address = {};
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();

        if (place.address_components) {
            place.address_components.forEach((addressItem: google.maps.GeocoderAddressComponent) => {
                const type: string = addressItem.types[0];

                address[type] = type == ProvinceResultType ? addressItem.short_name : addressItem.long_name;
            });
            OnPlaceChange(address);
        }
    };

    return (
        <div className="row">
            <div className="col-lg-4">
                <input id="autocomplete" ref={autocompleteInput} className="form-control" placeholder={Trad.Trad("Enter the address")} type="text" />
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/custom/AutocompleteInput/AutocompleteInput.tsx